import React from "react";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "context/BrandingContext";
import { UserBlock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import StatusPage from "components/common/StatusPage";

const Declined: React.FC = () => {
  const { t } = useTranslation();
  const { platform } = useBrandingContext();
  const supportEmail = platform?.email || "support@outpave.com";

  return (
    <StatusPage
      title={t("Your application was not approved")}
      message={t("DeclinedApplicationMessage")}
      icon={UserBlock01Icon}
      action={{
        label: t("Contact support"),
        href: `mailto:${supportEmail}`,
      }}
    />
  );
};

export default Declined;
